import React from 'react';
import { handleImageFailure } from './PlpTiles';

export const PlpTileHoverableImage = ({
  shouldRenderQuickAdd,
  primaryImageUrl,
  secondaryImageUrl,
  altText,
}: {
  shouldRenderQuickAdd: boolean;
  primaryImageUrl: string;
  secondaryImageUrl?: string | null;
  altText: string;
}) => {
  return shouldRenderQuickAdd ? (
    <div className="product-carousel quick-add-carousel">
      <div className="quick-add-carousel-images">
        <img
          className="lazyload normal"
          onError={handleImageFailure}
          alt={altText}
          src={primaryImageUrl}
          onMouseOver={(e) => {
            secondaryImageUrl && (e.currentTarget.src = secondaryImageUrl);
          }}
          onMouseOut={(e) => (e.currentTarget.src = primaryImageUrl)}
        />
      </div>
    </div>
  ) : (
    <img
      className="lazyload normal"
      onError={handleImageFailure}
      alt={altText}
      src={primaryImageUrl}
      onMouseOver={(e) => {
        secondaryImageUrl && (e.currentTarget.src = secondaryImageUrl);
      }}
      onMouseOut={(e) => (e.currentTarget.src = primaryImageUrl)}
    />
  );
};
